import React from 'react';
import { FirmAdminLayout } from './FirmAdminLayout';
import { LeaveApproval } from '../attendance';

const FirmAdminLeaveApproval: React.FC = () => {
  return (
    <FirmAdminLayout>
      <div className="p-6">
        <LeaveApproval userRole="FIRM_ADMIN" />
      </div>
    </FirmAdminLayout>
  );
};

export default FirmAdminLeaveApproval;
